import { Chip, Tooltip } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import { abyssColors } from '@/theme/colors';
import { ReportStatus } from '@/__generated__/graphql';
import { MouseEvent } from 'react';

const STATUS_COLORS: Record<ReportStatus, { fg: string; bg: string }> = {
  [ReportStatus.Draft]: {
    fg: abyssColors.warning[600],
    bg: abyssColors.warning[50],
  },
  [ReportStatus.Published]: {
    fg: abyssColors.success[600],
    bg: abyssColors.success[50],
  },
  [ReportStatus.Closed]: {
    fg: abyssColors.primary[600],
    bg: abyssColors.primary[50],
  },
  [ReportStatus.Deleted]: {
    fg: abyssColors.error[600],
    bg: abyssColors.error[50],
  },
};

type Props = {
  name: string;
  status: ReportStatus;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
  maxWidth?: number | string;
};

export const ReportChip = ({ name, status, onClick, maxWidth = 160 }: Props) => {
  const colors = STATUS_COLORS[status] ?? STATUS_COLORS[ReportStatus.Draft];
  return (
    <Tooltip title={name} placement="top" arrow>
      <Chip
        size="small"
        icon={
          <DescriptionIcon
            sx={{ fontSize: '1.4rem !important', color: `${colors.fg} !important` }}
          />
        }
        label={name}
        onClick={(event) => {
          event.stopPropagation();
          onClick(event);
        }}
        sx={{
          maxWidth,
          height: '2.4rem',
          fontSize: '1.2rem',
          fontWeight: 500,
          color: colors.fg,
          backgroundColor: colors.bg,
          border: `1px solid ${colors.bg}`,
          cursor: 'pointer',
          '& .MuiChip-label': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            paddingLeft: '0.4rem',
            paddingRight: '0.8rem',
          },
          '&:hover': {
            backgroundColor: colors.bg,
            filter: 'brightness(0.95)',
          },
        }}
      />
    </Tooltip>
  );
};
